import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsLoaderService {
  private scriptLoaded = false;

  constructor() { }

  loadUtils(): Promise<void> {
    if (this.scriptLoaded) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js'; // Ruta al archivo utils.js
      script.type = 'text/javascript';
      script.async = true;

      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };

      script.onerror = (error) => {
        console.error('Error loading utils.js:', error);
        reject(error);
      };

      document.body.appendChild(script);
    });
  }
}